import moment from 'moment-timezone'

export const DEFAULT_PLINKO_PINS = 8
export const DEFAULT_MIN_PLINKO_ROWS = 8
export const DEFAULT_MAX_PLINKO_ROWS = 16

export const DEFAULT_PLINKO_RISK_LEVEL = 1

export const DEFAULT_PLINKO_AUTO_BETS = 50

export const DEFAULT_NUMBER_OF_BALLS = 1

export const PLINKO_FIXED_ODDS = {
  8: [
    [5.6, 2.1, 1.1, 1, 0.5, 1, 1.1, 2.1, 5.6],
    [13, 3, 1.3, 0.7, 0.4, 0.7, 1.3, 3, 13],
    [29, 4, 1.5, 0.3, 0.2, 0.3, 1.5, 4, 29]
  ],
  9: [
    [5.6, 2, 1.6, 1, 0.7, 0.7, 1, 1.6, 2, 5.6],
    [18, 4, 1.7, 0.9, 0.5, 0.5, 0.9, 1.7, 4, 18],
    [43, 7, 2, 0.6, 0.2, 0.2, 0.6, 2, 7, 43]
  ],
  10: [
    [8.9, 3, 1.4, 1.1, 1, 0.5, 1, 1.1, 1.4, 3, 8.9],
    [22, 5, 2, 1.4, 0.6, 0.4, 0.6, 1.4, 2, 5, 22],
    [76, 10, 3, 0.9, 0.3, 0.2, 0.3, 0.9, 3, 10, 76]
  ],
  11: [
    [8.4, 3, 1.9, 1.3, 1, 0.7, 0.7, 1, 1.3, 1.9, 3, 8.4],
    [24, 6, 3, 1.8, 0.7, 0.5, 0.5, 0.7, 1.8, 3, 6, 24],
    [120, 14, 5.2, 1.4, 0.4, 0.2, 0.2, 0.4, 1.4, 5.2, 14, 120]],

  12: [
    [10, 3, 1.6, 1.4, 1.1, 1, 0.5, 1, 1.1, 1.4, 1.6, 3, 10],
    [33, 11, 4, 2, 1.1, 0.6, 0.3, 0.6, 1.1, 2, 4, 11, 33],
    [170, 24, 8.1, 2, 0.7, 0.2, 0.2, 0.2, 0.7, 2, 8.1, 24, 170]],

  13: [
    [8.1, 4, 3, 1.9, 1.2, 0.9, 0.7, 0.7, 0.9, 1.2, 1.9, 3, 4, 8.1],
    [43, 13, 6, 3, 1.3, 0.7, 0.4, 0.4, 0.7, 1.3, 3, 6, 13, 43],
    [260, 37, 11, 4, 1, 0.2, 0.2, 0.2, 0.2, 1, 4, 11, 37, 260]],

  14: [
    [7.1, 4, 1.9, 1.4, 1.3, 1.1, 1, 0.5, 1, 1.1, 1.3, 1.4, 1.9, 4, 7.1],
    [58, 15, 7, 4, 1.9, 1, 0.5, 0.2, 0.5, 1, 1.9, 4, 7, 15, 58],
    [420, 56, 18, 5, 1.9, 0.3, 0.2, 0.2, 0.2, 0.3, 1.9, 5, 18, 56, 420]],

  15: [
    [15, 8, 3, 2, 1.5, 1.1, 1, 0.7, 0.7, 1, 1.1, 1.5, 2, 3, 8, 15],
    [88, 18, 11, 5, 3, 1.3, 0.5, 0.3, 0.3, 0.5, 1.3, 3, 5, 11, 18, 88],
    [620, 83, 27, 8, 3, 0.5, 0.2, 0.2, 0.2, 0.2, 0.5, 3, 8, 27, 83, 620]],

  16: [
    [16, 9, 2, 1.4, 1.4, 1.2, 1.1, 1, 0.5, 1, 1.1, 1.2, 1.4, 1.4, 2, 9, 16],
    [110, 41, 10, 5, 3, 1.5, 1, 0.5, 0.3, 0.5, 1, 1.5, 3, 5, 10, 41, 110],
    [1000, 130, 26, 9, 4, 2, 0.2, 0.2, 0.2, 0.2, 0.2, 2, 4, 9, 26, 130, 1000]]
}
export const PLINKO_MULTIPLIER_COLORS = [
  ['#CA3A31', '#D9622B', '#C18D30', '#C18D30', '#4D5562', '#C18D30', '#C18D30', '#D9622B', '#CA3A31'],
  ['#CA3A31', '#D9622B', '#C18D30', '#C18D30', '#4D5562', '#4D5562', '#C18D30', '#C18D30', 0xF97706, '#CA3A31'],
  ['#CA3A31', '#D9622B', '#D9622B', '#C18D30', '#C18D30', '#4D5562', '#C18D30', '#C18D30', '#D9622B', '#D9622B', '#CA3A31'],
  ['#CA3A31', '#D9622B', '#D9622B', '#C18D30', '#C18D30', '#4D5562', '#4D5562', '#C18D30', '#C18D30', '#D9622B', '#D9622B', '#CA3A31'],
  ['#CA3A31', '#CA3A31', '#D9622B', '#D9622B', '#C18D30', '#C18D30', '#4D5562', '#4D5562', '#C18D30', '#C18D30', '#D9622B', '#D9622B', '#CA3A31'],
  ['#CA3A31', '#CA3A31', '#D9622B', '#D9622B', '#C18D30', '#C18D30', '#4D5562', '#4D5562', '#C18D30', '#C18D30', '#D9622B', '#D9622B', '#CA3A31', '#CA3A31'],
  ['#CA3A31', '#CA3A31', '#CA3A31', '#D9622B', '#D9622B', '#C18D30', '#C18D30', '#4D5562', '#C18D30', '#C18D30', '#D9622B', '#D9622B', '#CA3A31', '#CA3A31', '#CA3A31'],
  ['#CA3A31', '#CA3A31', '#CA3A31', '#CA3A31', '#D9622B', '#D9622B', '#C18D30', '#4D5562', '#4D5562', '#C18D30', '#D9622B', '#D9622B', '#CA3A31', '#CA3A31', '#CA3A31', '#CA3A31'],
  ['#CA3A31', '#CA3A31', '#CA3A31', '#CA3A31', '#D9622B', '#D9622B', '#C18D30', '#C18D30', '#4D5562', '#C18D30', '#C18D30', '#D9622B', '#D9622B', '#CA3A31', '#CA3A31', '#CA3A31', '#CA3A31']
]

export const PLINKO_MULTIPLIER_COLORS_AND_BORDER = {
  '#CA3A31': '#521814',
  '#D9622B': '#4C3130',
  '#C18D30': '#443931',
  '#4D5562': '#272E3E'
}

export const DEFAULT_PLINKO_LIGHTNING_MODE_BOARD = {
  betMultipliers: [{ position: [7, 8], multiplier: '2x' }, { position: [13, 10], multiplier: '15x' }, { position: [2, 2], multiplier: '40x' }],
  payouts: [1000, 155, 6.28, 1.09, 0.35, 0.16, 0, 0.02, 0, 0.01, 0, 0.07, 0.3, 1.4, 29.3, 157, 1000]
}

export const PLINKO_LIGHTNING_MODE_VARIABLE_ODDS = {
  1: [500, 125, 30, 5, 0.9, 0.3, 0, 0.1, 0, 0.1, 0, 0.3, 0.9, 5, 30, 125, 500],
  2: [1000, 155, 15, 3.59, 1.4, 0.69, 0, 0.07, 0, 0.04, 0, 0.17, 0.25, 0.46, 1.27, 8.43, 1000],
  3: [1000, 155, 6.28, 1.09, 0.35, 0.16, 0, 0.02, 0, 0.01, 0, 0.07, 0.3, 1.4, 29.3, 157, 1000],
  4: [1000, 6.39, 0.96, 0.32, 0.16, 0.09, 0, 0.02, 0, 0.03, 0, 0.61, 2.03, 7.42, 28.7, 152, 1000]
}

export const DEFAULT_AUTO_BET_COUNTER = 0

export const WALLET_EMIT_TYPES = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  RESOLVE: 'resolve',
  DEFAULT: 'default'
}

export const DEFAULT_PAGE_CALLS = 20

export const PLINKO_GAME_RISK_LEVEL = [
  {
    label: 'Low',
    value: 1
  },
  {
    label: 'Medium',
    value: 2
  },
  {
    label: 'High',
    value: 3
  }
]

export const PLINKO_GAME_RISK_LEVEL_OBJ = {
  1: 'Low',
  2: 'Medium',
  3: 'High'
}

export const formatePlinkoBetHistoryDate = (date) => {
  return moment.tz(date, moment.tz.guess()).format('MMMM D, YYYY(H:mm)')
}
